import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'aceptar-invitacion',
    loadComponent: () =>
      import('./pages/accept-invitation/accept-invitation.page').then(m => m.AcceptInvitationPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/layout/shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage),
      },
      {
        path: 'pacientes',
        loadComponent: () =>
          import('./pages/patients/patients.page').then(m => m.PatientsPage),
      },
      {
        path: 'pacientes/nuevo',
        loadComponent: () =>
          import('./pages/new-patient/new-patient.page').then(m => m.NewPatientPage),
      },
      {
        path: 'pacientes/:patientId',
        loadComponent: () =>
          import('./pages/patient-record/patient-record.page').then(m => m.PatientRecordPage),
      },
      {
        path: 'pacientes/:patientId/historia-clinica/nueva',
        loadComponent: () =>
          import('./pages/nueva-historia/nueva-historia.page').then(m => m.NuevaHistoriaPage),
      },
      {
        path: 'pacientes/:patientId/odontograma',
        loadComponent: () =>
          import('./pages/odontogram/odontogram.page').then(m => m.OdontogramPage),
      },
      {
        path: 'pacientes/:patientId/notas',
        loadComponent: () =>
          import('./pages/notes/notes.page').then(m => m.NotesPage),
      },
      {
        path: 'pacientes/:patientId/notas/nueva',
        loadComponent: () =>
          import('./pages/new-note/new-note.page').then(m => m.NewNotePage),
      },
      {
        path: 'pacientes/:patientId/notas/:notaId/editar',
        loadComponent: () =>
          import('./pages/new-note/new-note.page').then(m => m.NewNotePage),
      },
      {
        path: 'pacientes/:patientId/procedimientos',
        loadComponent: () =>
          import('./pages/procedure/procedure.page').then(m => m.ProcedurePage),
      },
      {
        path: 'pacientes/:patientId/procedimientos/nueva',
        loadComponent: () =>
          import('./pages/new-procedure/new-procedure.page').then(m => m.NewProcedurePage),
      },
      {
        path: 'pacientes/:patientId/urgencias',
        loadComponent: () =>
          import('./pages/urgencias/urgencias.page').then(m => m.UrgenciasPage),
      },
      {
        path: 'pacientes/:patientId/urgencias/nueva',
        loadComponent: () =>
          import('./pages/new-urgencia/new-urgencia.page').then(m => m.NewUrgenciaPage),
      },
      {
        path: 'pacientes/:patientId/consentimiento',
        loadComponent: () =>
          import('./pages/consent/consent.page').then(m => m.ConsentPage),
      },
      {
        path: 'pacientes/:patientId/consentimiento/nuevo',
        loadComponent: () =>
          import('./pages/new-consent/new-consent.page').then(m => m.NewConsentPage),
      },
      {
        path: 'pacientes/:patientId/radiografias',
        loadComponent: () =>
          import('./pages/radiology/radiology.page').then(m => m.RadiologyPage),
      },
      {
        path: 'agenda',
        loadComponent: () =>
          import('./pages/agenda/agenda.page').then(m => m.AgendaPage),
      },
      {
        path: 'perfil',
        loadComponent: () =>
          import('./pages/perfil/perfil.page').then(m => m.PerfilPage),
      },
      {
        path: 'clinica',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/clinica/clinica.page').then(m => m.ClinicaPage),
      },
      {
        path: 'clinica/doctores/:doctorId/horario',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/doctor-schedule/doctor-schedule.page').then(m => m.DoctorSchedulePage),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
